import { hooks, Card, CardContent, Skeleton, Text } from '@bitrise/bitkit';
import { SessionAttributes as SessionAttributesType, TypeAttribute } from '@trace/types';
import React, { FunctionComponent } from 'react';

import dataAtIds from '../../dataAtIds.json';
import { ATTRIBUTE_SESSION_ORDER } from '../../constants/Attributes';
import AttributeStatGrid from '../AttributeStat/AttributeStatGrid';

interface Props {
  attributes: SessionAttributesType;
  duration?: number;
  isFetching: boolean;
  timestamp?: number;
}

const SessionAttributes: FunctionComponent<Props> = ({
  attributes,
  duration,
  isFetching,
  timestamp,
}) => {
  const match = hooks.useMediaQuery(['1056px']);

  const getAttributeValue = (attribute: TypeAttribute) => {
    switch (attribute) {
      case 'duration':
        return duration;
      case 'timestamp':
        return timestamp;
      default:
        return attributes[attribute];
    }
  };

  return (
    <Skeleton active={isFetching} margin="x8">
      <Card direction="vertical" padding="x8">
        <CardContent data-trace-at-id={dataAtIds.SessionExplorerAttributes}>
          <Text config="5" margin="x8">
            Session attributes
          </Text>

          <AttributeStatGrid
            attributes={ATTRIBUTE_SESSION_ORDER.map((attribute) => ({
              attribute,
              value: getAttributeValue(attribute),
            }))}
            attributesPerRow={match('1056px') ? 4 : 2}
            showLoadingIndicator={isFetching}
            withIcon
          />
        </CardContent>
      </Card>
    </Skeleton>
  );
};

export default SessionAttributes;
